import { render, staticRenderFns } from "./korean_resources.vue?vue&type=template&id=46f0999b&scoped=true"
import script from "./korean_resources.vue?vue&type=script&lang=js"
export * from "./korean_resources.vue?vue&type=script&lang=js"
import style0 from "./korean_resources.vue?vue&type=style&index=0&id=46f0999b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0999b",
  null
  
)

export default component.exports